import { render } from "./FormAct.vue?vue&type=template&id=62e56da3&scoped=true"
import script from "./FormAct.vue?vue&type=script&lang=js"
export * from "./FormAct.vue?vue&type=script&lang=js"

import "./FormAct.vue?vue&type=style&index=0&id=62e56da3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62e56da3"]])

export default __exports__